import classNames from 'classnames/bind';
import { IKeyAnyValue } from 'common/types';
import { SearchType } from 'contexts/searchParams';
import { useFilterNoticeHide } from 'hooks/useFilterSave';
import { useState } from 'react';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

interface IProps {
  storedFilter: IKeyAnyValue | null;
  resetFilters: () => void;
  hasSavedFilter: boolean;
  searchType: SearchType;
}

export default function SavedFilterAlert({
  storedFilter,
  resetFilters,
  hasSavedFilter,
  searchType,
}: IProps) {
  const [visible, setVisible] = useState(hasSavedFilter);
  const [isHideNotice, hideNotice] = useFilterNoticeHide(searchType);

  if (!visible) {
    return null;
  }

  const savedFilter = Object.keys(storedFilter || {});
  if (
    savedFilter.length === 1 &&
    (savedFilter[0] === 'airlines' || savedFilter[0] === 'airlineCode')
  ) {
    const airline: any = Object.values(storedFilter?.[savedFilter[0]])[0];

    const clearAndHide = () => {
      resetFilters();
      setVisible(false);
    };

    return (
      <div className={cx('SavedFilterAlert')}>
        <div className={cx('inner')}>
          <p className={cx('txt')}>
            {airline} 항공사 조건이 적용된 조회 결과입니다.
          </p>
          <button
            className={cx('dismiss')}
            type="button"
            data-event-nlog="click"
            data-event-area-code="isr.keepclose"
            onClick={clearAndHide}
          >
            전체 항공사 보기
          </button>
          <button
            className={cx('close')}
            type="button"
            aria-label="닫기"
            data-event-nlog="click"
            data-event-area-code="isr.guideclose"
            onClick={() => setVisible(false)}
          />
        </div>
      </div>
    );
  }

  const handleHide = () => {
    hideNotice();
    setVisible(false);
  };

  if (isHideNotice) return null;

  return (
    <div className={cx('SavedFilterAlert')}>
      <div className={cx('inner')}>
        <p className={cx('txt')}>
          마지막 선택한 상세조건이 적용된 조회 결과입니다.
        </p>
        <button
          className={cx('dismiss')}
          type="button"
          data-event-nlog="click"
          data-event-area-code="isr.keepclose"
          onClick={handleHide}
        >
          다시 보지 않기
        </button>
        <button
          className={cx('close')}
          type="button"
          aria-label="닫기"
          data-event-nlog="click"
          data-event-area-code="isr.guideclose"
          onClick={() => setVisible(false)}
        />
      </div>
    </div>
  );
}
